import { TradingDatagridV3Interface } from '@trading-ui/datagrid-v3';
import { create } from 'zustand';

interface ConsumerTableStoreState {
  tableInstance: TradingDatagridV3Interface | null;
  saveTableInstance: (tableInstance: TradingDatagridV3Interface) => void;
}

const useConsumerTableStore = create<ConsumerTableStoreState>((set) => ({
  tableInstance: null,
  saveTableInstance: (tableInstance) => set((state) => ({ ...state, tableInstance })),
}));

export default useConsumerTableStore;
